
















































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Card from '@/components/default/Card.vue';
import { DxPopup } from 'devextreme-vue/popup';
import { DxButton, DxTextBox } from 'devextreme-vue';
import { DxTreeList, DxEditing, DxRowDragging, DxColumnFixing, DxStateStoring } from 'devextreme-vue/tree-list';
import { QuotationBlock, IQuotationLine, QuotationLine, QuotationDetailedDto, IArticle, IVariant, TunnelGroup, RawMaterialGroup, Article } from '@/data/web-api-client';
import AddArticleDialog from '@/modules/quotations/components/dialogs/AddArticleDialog.vue';
import notificationService from '@/services/notificationService';
import { on } from 'devextreme/events';
import DxTooltip from 'devextreme-vue/tooltip';
import DefineCostsDialog from './dialogs/DefineCostsDialog.vue';

@Component({
  components: {
    Card,
    DxTreeList,
    DxEditing,
    DxRowDragging,
    DxColumnFixing,
    DxStateStoring,
    DxPopup,
    DxTextBox,
    AddArticleDialog,
    DxTooltip,
    DefineCostsDialog,
  },
})
export default class QuotationBlockCard extends Vue {
  declare currency: any;

  @Prop({ required: true })
  value!: QuotationBlock;

  @Prop({ required: true })
  quotation!: QuotationDetailedDto;

  @Prop({ required: true })
  summary!: Array<{
    articleId: string;
    quantity: number;
    unitPrice: number;
  }>;

  @Prop()
  tunnelGroups!: TunnelGroup[];

  @Prop()
  rawMaterialGroups!: RawMaterialGroup[];

  @Prop({ required: true })
  calculatedBlockData!: Map<string, any>;

  @Prop({ required: false, default: false })
  editDisabled!: boolean;

  @Prop()
  forceUpdate!: boolean;

  parentRecordId: string | null = null;
  showEditNamePopup: boolean = false;
  editedPrice: Map<string, number> = new Map();
  editedCost: Map<string, number> = new Map();

  currentOfferLine: any | null = null;

  beforeUpdate() {}

  removeBlock() {
    this.$emit('remove');
  }

  openAddArticle(parentId: string | null) {
    this.parentRecordId = parentId;
    (this.$refs.AddArticleDialog as AddArticleDialog).show = true;
  }

  saveName() {
    this.showEditNamePopup = false;
  }

  addArticle(input: {
    article: IArticle;
    data: {
      articleId: string;
      quantity: number;
    };
  }) {
    // addArticleDialog
    const dialog = this.$refs.AddArticleDialog as AddArticleDialog;
    try {
      dialog.updating = true;

      const articleVariant = input.article.variants && input.article.variants.length > 0 ? input.article.variants[0] : undefined;
      if (!articleVariant) {
        throw Error('Variant not found');
      }
      const salesPrice = (articleVariant as IVariant)!.salesPrices!.find((o) => o.type === this.quotation.projectType);
      if (!salesPrice) {
        throw Error('Pricing not found');
      }

      const labourCost =
        input.article.labourCosts && input.article.labourCosts.length > 0 ? input.article.labourCosts.find((lc) => lc.type == this.quotation.projectType) : undefined;

      const rawMaterials = articleVariant.materials?.map((av) => {
        const rawMaterial = this.rawMaterials.find((rm) => rm.id == av.rawMaterialRef);

        return rawMaterial?.defaultPrice ? (rawMaterial?.defaultPrice?.purchasePriceDefaultMeasuringUnit! ?? 0) * av.amount! : 0!;
      });

      const materialCost = rawMaterials != null && rawMaterials.length > 0 ? rawMaterials.reduce((a, b) => a! + b!) : 0;

      const newLine = new QuotationLine({
        lineId: this.getGuid(),
        parentLineId: this.parentRecordId === null ? undefined : this.parentRecordId,
        articleId: input.data.articleId,
        articleCategoryId: input.article.categoryId,
        variant: input.article.variants && input.article.variants.length > 0 ? input.article.variants[0].name : '',
        measuringUnit: input.article.measuringUnit,
        quantity: input.data.quantity,
        price: salesPrice.price,
        originalPrice: salesPrice.price,
        cost: salesPrice.cost,
        discount: 0,
        description: `${input.article.name}: ${input.article.description}`,
        remarks: '',
        total: input.data.quantity * salesPrice.price!,
        originalTotal: input.data.quantity * salesPrice.price!,
        margin: input.data.quantity * (salesPrice.price! - salesPrice.cost!),
        minimumDuration: labourCost?.minimumLabourDuration,
        targetDurationOfArticle: labourCost?.targetDuration,
        originalMaterialCost: materialCost,
        originalLabourCost: labourCost?.cost,
        originalCost: salesPrice.cost,
        labourCost: labourCost?.cost,
        salesPriceMargin: salesPrice.margin! / 100,
        materialCost: materialCost,
      });

      this.value.lines!.push(newLine);

      this.$emit('rowUpdated', newLine.lineId);

      const instance = (this.$refs.treelist as any).instance;
      if (instance) {
        instance.refresh();
      }

      dialog.show = false;
    } catch (err) {
      notificationService.showErrorMessage('Artikel kon niet toegevoegd worden');
    } finally {
      dialog.updating = false;
    }
  }

  getGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      // tslint:disable-next-line
      const r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  rowUpdated(e: any) {
    this.$emit('rowUpdated', e.data.lineId);
  }

  rowDeleted(e: any) {
    this.deleteWithParentId(e.data.lineId);
  }

  deleteWithParentId(parentId: string) {
    if (!this.value.lines) {
      return;
    }

    const deletedIds: string[] = [];
    for (let i = this.value.lines!.length - 1; i >= 0; i--) {
      const line = this.value.lines[i];
      if (line.parentLineId === parentId) {
        deletedIds.push(line.lineId!);
        this.value.lines.splice(i, 1);
      }
    }

    deletedIds.forEach((id) => {
      this.deleteWithParentId(id);
    });
  }

  rowInserting(e: any) {
    const data = e.data as IQuotationLine;
    data.lineId = this.getGuid();
    this.value.lines!.unshift(new QuotationLine(data));
    const instance = (this.$refs.treelist as any).instance;
    if (instance) {
      instance.cancelEditData();
    }

    e.cancel = true;
  }

  addRow(parentId: string | null) {
    this.parentRecordId = parentId;
    const instance = (this.$refs.treelist as any).instance!;

    if (instance) {
      instance.addRow(parentId);
      instance.refresh();
      instance.repaintRows();
    }
  }

  setTextColor(e: any) {
    // price
    if (e.rowType === 'data' && e.column && e.column.caption && e.column.caption === 'Prijs') {
      if (e.data.price < e.data.originalPrice) {
        $(e.cellElement).addClass('text-danger');
      }
      if (e.data.price > e.data.originalPrice) {
        $(e.cellElement).addClass('text-success');
      }
    }
    // margin
    if (e.rowType === 'data' && e.column && e.column.caption && e.column.caption === 'Marge') {
      if (e.data.price < e.data.cost) {
        $(e.cellElement).addClass('text-danger');
      }
      if (e.data.price > e.data.cost) {
        $(e.cellElement).addClass('text-success');
      }
    }
    // Total margin
    if (e.rowType === 'data' && e.column && e.column.caption && e.column.caption === 'Marge op totaal') {
      if (e.data.price < e.data.cost) {
        $(e.cellElement).addClass('text-danger');
      }
      if (e.data.price > e.data.cost) {
        $(e.cellElement).addClass('text-success');
      }
    }

    if (e.rowType === 'data' && e.column.dataField === 'cost' && e.data.cost !== undefined) {
      const self = this;
      const infoEl = document.createElement('i');

      infoEl.classList.add('fas', 'fa-info-circle');
      infoEl.style.marginLeft = '6px';

      $(e.cellElement).append(infoEl);

      on(infoEl, 'mouseover', (arg: any) => {
        const offerLine = e.data;
        const calculatedLine = this.calculatedBlockData?.get(offerLine.lineId);

        console.log('QuotationBlockCard ~ on ~ calculatedLine:', calculatedLine);
        if (calculatedLine) {
          offerLine.newEstimatedWorkMinutes = parseFloat((offerLine.targetDurationOfArticle ?? 0) + (calculatedLine.extraWorkMinutes ?? 0)).toFixed(2);
          offerLine.newMaterialCost = parseFloat(calculatedLine.materialCost ?? 0).toFixed(2);
          offerLine.newCost = parseFloat((calculatedLine.labourCost ?? 0) + (calculatedLine.materialCost ?? 0)).toFixed(2);
          if (offerLine.newCost == offerLine.cost) {
            offerLine.newCost = parseFloat(offerLine.cost ?? 0).toFixed(2);
          }
        } else {
          offerLine.newEstimatedWorkMinutes = parseFloat(offerLine.targetDurationOfArticle ?? 0).toFixed(2);
          offerLine.newMaterialCost = parseFloat(offerLine.materialCost ?? 0).toFixed(2);
          offerLine.newCost = parseFloat((offerLine.labourCost ?? 0) + (offerLine.materialCost ?? 0)).toFixed(2);
          if (offerLine.newCost == offerLine.cost) {
            offerLine.newCost = parseFloat(offerLine.cost ?? 0).toFixed(2);
          }
        }

        this.currentOfferLine = offerLine;

        (self.$refs.tooltip as any).instance.show(arg.target);
      });

      on(infoEl, 'mouseout', (arg: any) => {
        (self.$refs.tooltip as any).instance.hide().then(() => {
          this.currentOfferLine = undefined;
        });
      });
    }
  }

  onReorderLine(e: any) {
    const visibleRows = e.component.getVisibleRows();
    const sourceData = e.itemData;
    const targetData = visibleRows[e.toIndex].data;

    if (sourceData.lineId == targetData.parentLineId) {
      // User tried to drag a parent line in one of its child lines.
      // Not allowed
      return;
    }

    if (e.dropInsideItem) {
      e.itemData.parentLineId = targetData.lineId;
      e.component.refresh();
    } else {
      const sourceIndex = this.value.lines!.indexOf(sourceData);
      let targetIndex = this.value.lines!.indexOf(targetData);

      if (sourceData.parentLineId !== targetData.parentLineId) {
        sourceData.parentLineId = targetData.parentLineId;
        if (e.toIndex > e.fromIndex) {
          targetIndex++;
        }
      }

      this.value.lines!.splice(sourceIndex, 1);
      this.value.lines!.splice(targetIndex, 0, sourceData);
    }
  }

  updateNotes(e: any) {
    const promptValue = prompt('Opmerking', e.row.data.remarks);
    if (promptValue) {
      e.row.data.remarks = promptValue;
    }
  }
  public saveEditDataOfTreeList() {
    const treelist = this.$refs.treelist as DxTreeList;
    if (!treelist) {
      return;
    }

    return treelist.instance?.saveEditData();
  }

  openDefineCostsDialog(line: QuotationLine) {
    (this.$refs.defineCostsDialog as any).open(line);
  }

  updateLineInBlock(line: QuotationLine) {
    if (!this.value.lines) {
      return;
    }

    const index = this.value.lines!.findIndex((l) => l.lineId == line.lineId);
    if (index > -1) {
      this.value.lines[index] = new QuotationLine(line);
      this.$emit('rowUpdated', line.lineId);
    }
  }

  get measuringUnits() {
    const measuringUnits = this.$store.getters['measuringUnits/data'];

    return measuringUnits ?? [];
  }

  get rawMaterials(): any[] {
    return this.$store.getters['rawmaterials/items'];
  }

  get articles(): Article[] {
    return this.$store.getters['articles/items'];
  }

  get total() {
    let res = 0;
    if (!this.value.lines || this.value.lines.length <= 0) {
      return res;
    }

    this.value.lines.forEach((line: any) => {
      if (line.quantity && line.price) {
        const price = this.editedPrice.get(line.lineId!) ? line.price : this.calculatedBlockData?.get(line.articleId!)?.price ?? line.price;

        res += price * line.quantity;
      }
    });

    return res;
  }

  get totalOriginal() {
    let res = 0;
    if (!this.value.lines || this.value.lines.length <= 0) {
      return res;
    }

    this.value.lines.forEach((line: QuotationLine) => {
      if (!line.articleId && line.price && line.quantity) {
        res += line.quantity * line.price;
        return;
      }
      if (line.quantity && line.originalPrice) {
        res += line.quantity * line.originalPrice;
      }
    });

    return res;
  }

  get margin() {
    let res = 0;
    if (!this.value.lines || this.value.lines.length <= 0 || !this.calculatedBlockData) {
      return res;
    }

    this.value.lines.forEach((line: any) => {
      const labourCost = this.calculatedBlockData?.get(line.lineId!)?.labourCost;
      const materialCost = this.calculatedBlockData?.get(line.lineId!)?.materialCost;

      const cost = this.editedCost.get(line.lineId!) ? line.cost : labourCost && materialCost ? labourCost + materialCost : line.cost;

      const price = this.editedPrice.get(line.lineId!) ? line.price : this.calculatedBlockData?.get(line.lineId!)?.price ?? line.price;

      // Calculate margin
      if (line.quantity && line.price) {
        res += line.quantity * (price - cost);
      }
    });

    return res;
  }

  get disabled() {
    return this.quotation.status! > 1;
  }

  get columns() {
    const self = this;

    return [
      {
        dataField: 'description',
        caption: 'Beschrijving',
      },
      {
        dataField: 'measuringUnit',
        caption: 'Meeteenh.',
        lookup: {
          dataSource: self.measuringUnits,
        },
      },
      {
        dataField: 'quantity',
        caption: 'Hoeveelheid',
        dataType: 'number',
        alignment: 'left',
        calculateCellValue(quotationLine: IQuotationLine) {
          if (self.calculatedBlockData?.get(quotationLine.lineId!) != undefined) {
            const data = self.calculatedBlockData?.get(quotationLine.lineId!);
            quotationLine.price = data.price as number;
          }
          if (quotationLine.quantity) {
            const quantity = Math.round(quotationLine.quantity! * 1000) / 1000;

            // if manual line fill in the amount so that it shows up on the measuringState
            if (!quotationLine.articleId) {
              quotationLine.amount = quantity;
            }
            return quantity;
          }

          return 0;
        },
      },
      {
        dataField: 'price',
        caption: 'Prijs',
        dataType: 'number',
        alignment: 'left',
        format: {
          type: 'currency',
          precision: 2,
        },
        setCellValue(newData: any, value: any, currentRowData: any) {
          console.log('QuotationBlockCard ~ setCellValue ~ value:', value);
          console.log('QuotationBlockCard ~ setCellValue ~ newData:', newData);
          if (value == currentRowData.originalPrice) {
            console.log('QuotationBlockCard ~ setCellValue ~ currentRowData.originalPrice:', currentRowData.originalPrice);
            self.editedPrice.delete(currentRowData.lineId);
            newData.price = currentRowData.originalPrice;
          }

          self.editedPrice.set(currentRowData.lineId, value);
          self.$emit('pricesEdited', self.editedPrice);

          newData.price = value;
          newData.lineId = currentRowData.lineId;
        },
      },
      {
        dataField: 'cost',
        caption: 'Kost',
        dataType: 'number',
        alignment: 'left',
        format: {
          type: 'currency',
          precision: 2,
        },
        setCellValue(newData: any, value: any, currentRowData: any) {
          if (value == currentRowData.originalCost) {
            self.editedCost.delete(currentRowData.lineId);
            newData.cost = currentRowData.originalCost;
          }
          self.editedCost.set(currentRowData.lineId, value);
          self.$emit('costsEdited', self.editedCost);

          console.log('QuotationBlockCard ~ setCellValue ~ isNaN(value):', isNaN(value));

          newData.cost = value;
          newData.lineId = currentRowData.lineId;
        },
        calculateDisplayValue(quotationLine: any) {
          if (!quotationLine.articleId) {
            return quotationLine.newCost ?? quotationLine.cost;
          }

          const editedCost = self.editedCost.get(quotationLine.lineId);
          if (editedCost != undefined) {
            return editedCost;
          }

          const calculatedLine = self.calculatedBlockData?.get(quotationLine.lineId);

          if (!calculatedLine) {
            if (!quotationLine.newCost || quotationLine.newCost != quotationLine.cost) {
              return quotationLine.cost;
            }

            return quotationLine.newCost;
          }

          const labourCost = calculatedLine.labourCost ?? 0;
          const materialCost = calculatedLine.materialCost ?? 0;

          const calcCost = labourCost + materialCost;

          if (calcCost == 0 || calcCost == quotationLine.cost) {
            return quotationLine.cost;
          }

          return calcCost;
        },
      },
      {
        alignment: 'left',
        formItem: {
          visible: false,
        },
        caption: 'Orginele prijs',
        cssClass: '',
        format: {
          type: 'currency',
          precision: 2,
        },
        calculateCellValue(value: any) {
          if (value.originalPrice) {
            return value.originalPrice;
          }
          return 0;
        },
      },
      {
        alignment: 'left',
        formItem: {
          visible: false,
        },
        caption: 'Marge',
        cssClass: '',
        format: {
          type: 'currency',
          precision: 2,
        },
        calculateCellValue(quotationLine: any) {
          if (self.calculatedBlockData?.get(quotationLine.lineId!) == undefined) {
            if (isNaN(quotationLine.price)) {
              return 0;
            }

            if (isNaN(quotationLine.cost)) {
              return quotationLine.price;
            }

            return quotationLine.price - quotationLine.cost;
          }

          const editedCost = self.calculatedBlockData.get(quotationLine.lineId).cost as number;

          let lineCost = (self.calculatedBlockData?.get(quotationLine.lineId!).labourCost ?? 0) + (self.calculatedBlockData?.get(quotationLine.lineId!).materialCost ?? 0);
          if (!isNaN(lineCost) && lineCost == 0 && quotationLine.newCost != 0) {
            lineCost = quotationLine.newCost ?? 0;
          }

          if (editedCost) {
            lineCost = editedCost;
          }

          return (self.calculatedBlockData?.get(quotationLine.lineId!).price as number) - lineCost;
        },
      },
      {
        alignment: 'left',
        formItem: {
          visible: false,
        },
        caption: 'Marge op totaal',
        cssClass: '',
        format: {
          type: 'currency',
          precision: 2,
        },
        calculateCellValue(quotationLine: any) {
          if (isNaN(quotationLine.quantity!) || quotationLine.quantity == 0) {
            return 0;
          }
          if (self.calculatedBlockData?.get(quotationLine.lineId!) == undefined) {
            if (isNaN(quotationLine.price!)) {
              return 0;
            }

            if (isNaN(quotationLine.cost!)) {
              return quotationLine.price! * quotationLine.quantity!;
            }

            return (quotationLine.price! - quotationLine.cost!) * quotationLine.quantity!;
          }

          const editedCost = self.calculatedBlockData.get(quotationLine.lineId!).cost as number;

          let lineCost = (self.calculatedBlockData?.get(quotationLine.lineId!).labourCost ?? 0) + (self.calculatedBlockData?.get(quotationLine.lineId!).materialCost ?? 0);
          if (!isNaN(lineCost) && lineCost == 0 && quotationLine.newCost! != 0) {
            lineCost = quotationLine.newCost! ?? 0;
          }

          if (editedCost) {
            lineCost = editedCost;
          }

          return ((self.calculatedBlockData?.get(quotationLine.lineId!).price as number) - lineCost) * quotationLine.quantity!;
        },
      },
      {
        alignment: 'left',
        formItem: {
          visible: false,
        },
        caption: 'Totaal',
        cssClass: '',
        format: {
          type: 'currency',
          precision: 2,
        },
        calculateCellValue(quotationLine: any) {
          if (quotationLine.quantity && quotationLine.price) {
            if (self.calculatedBlockData?.get(quotationLine.lineId!) == undefined) {
              return quotationLine.price! * quotationLine.quantity!;
            }

            return self.calculatedBlockData.get(quotationLine.lineId!).total as number;
          }
          return 0;
        },
      },
      {
        dataField: 'remarks',
        caption: 'Opmerkingen',
        dataType: 'text',
        visible: true,
      },
      {
        type: 'buttons',
        buttons: [
          {
            hint: 'Manuele lijn kosten defini�ren',
            icon: 'fas fa-pencil',
            visible: (e: any) => {
              const line = e.row.data as QuotationLine;
              if (!line.articleId) {
                return true;
              }
              return false;
            },
            onClick: (e: any) => {
              this.openDefineCostsDialog(e.row.data);
            },
          },
          {
            hint: 'Opmerking',
            icon: 'fas fa-comment-dots',
            visible(e: any) {
              return !e.row.isEditing && !e.row.data.isCompleted && !self.disabled && !self.editDisabled;
            },
            onClick: this.updateNotes,
          },
          {
            hint: 'Code invoegen',
            icon: 'fas fa-search-plus',
            visible(e: any) {
              return !e.row.isEditing && !e.row.data.isCompleted && !self.disabled && !self.editDisabled;
            },
            onClick: (e: any) => {
              this.openAddArticle(e.row.data.lineId);
            },
          },
          {
            hint: 'Verbergen',
            icon: 'fas fa-eye',
            visible(e: any) {
              return !e.row.isEditing && !e.row.data.hidden && !self.disabled && !self.editDisabled;
            },
            onClick: (e: any) => {
              self.value.lines!.find((line) => line.lineId === e.row.data.lineId)!.hidden = true;
              (this.$refs.treelist as any).instance.repaint();
            },
          },
          {
            hint: 'Tonen',
            icon: 'fas fa-eye-slash',
            visible(e: any) {
              return !e.row.isEditing && e.row.data.hidden && !self.disabled;
            },
            onClick: (e: any) => {
              self.value.lines!.find((line) => line.lineId === e.row.data.lineId)!.hidden = false;
              (this.$refs.treelist as any).instance.repaint();
            },
          },
          'edit',
          'delete',
        ] as DxButton[],
      },
    ];
  }

  @Watch('forceUpdate')
  forceUpdateTable() {
    const instance = (this.$refs.treelist as any)?.instance;
    if (instance) {
      instance.refresh();
    }
  }
}
